import { CrcatType, HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '../../models';
import { SYSTEM_ENUM_ROOT } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Credential Requirement Catalog Type`;

export type CPCrcatTypeLocs =
	| 'CPCrcatTypeEnumAdditionalAgreement'
	| 'CPCrcatTypeEnumCeActivity'
	| 'CPCrcatTypeEnumCertAgreement'
	| 'CPCrcatTypeEnumEnrollment'
	| 'CPCrcatTypeEnumExternalCert'
	| 'CPCrcatTypeEnumExternalExam'
	| 'CPCrcatTypeEnumLab'
	| 'CPCrcatTypeEnumMiscellaneous'
	| 'CPCrcatTypeEnumParticipation'
	| 'CPCrcatTypeEnumProgramFee'
	| 'CPCrcatTypeEnumStandingLengthyCert'
	| 'CPCrcatTypeEnumStandingMultiCert'
	| 'CPCrcatTypeEnumTraining';

export type SPCrcatTypeLocs =
	| 'SPCrcatTypeEnumAdditionalAgreement'
	| 'SPCrcatTypeEnumCeActivity'
	| 'SPCrcatTypeEnumCertAgreement'
	| 'SPCrcatTypeEnumEnrollment'
	| 'SPCrcatTypeEnumExternalCert'
	| 'SPCrcatTypeEnumExternalExam'
	| 'SPCrcatTypeEnumLab'
	| 'SPCrcatTypeEnumMiscellaneous'
	| 'SPCrcatTypeEnumParticipation'
	| 'SPCrcatTypeEnumProgramFee'
	| 'SPCrcatTypeEnumStandingLengthyCert'
	| 'SPCrcatTypeEnumStandingMultiCert'
	| 'SPCrcatTypeEnumTraining';

export const cpCrcatTypeEnumLocs: LocDefs<CPCrcatTypeLocs> = {
	CPCrcatTypeEnumAdditionalAgreement: {
		defaultValue: 'Additional Agreement',
		displayPath: `${dpRoot}|${CrcatType.AdditionalAgreement}`,
		description: `Credential requirement catalog type: '${CrcatType.AdditionalAgreement}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.AdditionalAgreement',
		portal: 'CP',
	},
	CPCrcatTypeEnumCeActivity: {
		defaultValue: 'CE Activity',
		displayPath: `${dpRoot}|${CrcatType.CeActivity}`,
		description: `Credential requirement catalog type: '${CrcatType.CeActivity}'`,
		displayType: 'Content',
		feature: HubFeature.CredentialContinuingEducation,
		legacyName: 'Credential.ContinuingEducation/System.Enum.CrcatType.CEActivity',
		portal: 'CP',
	},
	CPCrcatTypeEnumCertAgreement: {
		defaultValue: 'Certification Agreement',
		displayPath: `${dpRoot}|${CrcatType.CertAgreement}`,
		description: `Credential requirement catalog type: '${CrcatType.CertAgreement}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.CertAgreement',
		portal: 'CP',
	},
	CPCrcatTypeEnumEnrollment: {
		defaultValue: 'Enrollment',
		displayPath: `${dpRoot}|${CrcatType.Enrollment}`,
		description: `Credential requirement catalog type: '${CrcatType.Enrollment}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.Enrollment',
		portal: 'CP',
	},
	CPCrcatTypeEnumExternalCert: {
		defaultValue: 'External Certification',
		displayPath: `${dpRoot}|${CrcatType.ExternalCert}`,
		description: `Credential requirement catalog type: '${CrcatType.ExternalCert}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.ExternalCert',
		portal: 'CP',
	},
	CPCrcatTypeEnumExternalExam: {
		defaultValue: 'External Exam',
		displayPath: `${dpRoot}|${CrcatType.ExternalExam}`,
		description: `Credential requirement catalog type: '${CrcatType.ExternalExam}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.ExternalExam',
		portal: 'CP',
	},
	CPCrcatTypeEnumLab: {
		defaultValue: 'Lab',
		displayPath: `${dpRoot}|${CrcatType.Lab}`,
		description: `Credential requirement catalog type: '${CrcatType.Lab}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.Lab',
		portal: 'CP',
	},
	CPCrcatTypeEnumMiscellaneous: {
		defaultValue: 'Miscellaneous',
		displayPath: `${dpRoot}|${CrcatType.Miscellaneous}`,
		description: `Credential requirement catalog type: '${CrcatType.Miscellaneous}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.Miscellaneous',
		portal: 'CP',
	},
	CPCrcatTypeEnumParticipation: {
		defaultValue: 'Participation',
		displayPath: `${dpRoot}|${CrcatType.Participation}`,
		description: `Credential requirement catalog type: '${CrcatType.Participation}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.Participation',
		portal: 'CP',
	},
	CPCrcatTypeEnumProgramFee: {
		defaultValue: 'Program Fee',
		displayPath: `${dpRoot}|${CrcatType.ProgramFee}`,
		description: `Credential requirement catalog type: '${CrcatType.ProgramFee}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.ProgramFee',
		portal: 'CP',
	},
	CPCrcatTypeEnumStandingLengthyCert: {
		defaultValue: 'Standing Lengthy Certification',
		displayPath: `${dpRoot}|${CrcatType.StandingLengthyCert}`,
		description: `Credential requirement catalog type: '${CrcatType.StandingLengthyCert}'`,
		displayType: 'Content',
		feature: HubFeature.CredentialAchievements,
		legacyName: 'Credential.Achievements/System.Enum.CrcatType.StandingLengthyCert',
		portal: 'CP',
	},
	CPCrcatTypeEnumStandingMultiCert: {
		defaultValue: 'Standing Multi Certification',
		displayPath: `${dpRoot}|${CrcatType.StandingMultiCert}`,
		description: `Credential requirement catalog type: '${CrcatType.StandingMultiCert}'`,
		displayType: 'Content',
		feature: HubFeature.CredentialAchievements,
		legacyName: 'Credential.Achievements/System.Enum.CrcatType.StandingMultiCert',
		portal: 'CP',
	},
	CPCrcatTypeEnumTraining: {
		defaultValue: 'Training',
		displayPath: `${dpRoot}|${CrcatType.Training}`,
		description: `Credential requirement catalog type: '${CrcatType.Training}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.Training',
		portal: 'CP',
	},
};

export const spCrcatTypeEnumLocs: LocDefs<SPCrcatTypeLocs> = {
	SPCrcatTypeEnumAdditionalAgreement: {
		defaultValue: 'Additional Agreement',
		displayPath: `${dpRoot}|${CrcatType.AdditionalAgreement}`,
		description: `Credential requirement catalog type: '${CrcatType.AdditionalAgreement}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.AdditionalAgreement',
		portal: 'SP',
	},
	SPCrcatTypeEnumCeActivity: {
		defaultValue: 'CE Activity',
		displayPath: `${dpRoot}|${CrcatType.CeActivity}`,
		description: `Credential requirement catalog type: '${CrcatType.CeActivity}'`,
		displayType: 'Content',
		feature: HubFeature.CredentialContinuingEducation,
		legacyName: 'Credential.ContinuingEducation/System.Enum.CrcatType.CEActivity',
		portal: 'SP',
	},
	SPCrcatTypeEnumCertAgreement: {
		defaultValue: 'Certification Agreement',
		displayPath: `${dpRoot}|${CrcatType.CertAgreement}`,
		description: `Credential requirement catalog type: '${CrcatType.CertAgreement}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.CertAgreement',
		portal: 'SP',
	},
	SPCrcatTypeEnumEnrollment: {
		defaultValue: 'Enrollment',
		displayPath: `${dpRoot}|${CrcatType.Enrollment}`,
		description: `Credential requirement catalog type: '${CrcatType.Enrollment}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.Enrollment',
		portal: 'SP',
	},
	SPCrcatTypeEnumExternalCert: {
		defaultValue: 'External Certification',
		displayPath: `${dpRoot}|${CrcatType.ExternalCert}`,
		description: `Credential requirement catalog type: '${CrcatType.ExternalCert}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.ExternalCert',
		portal: 'SP',
	},
	SPCrcatTypeEnumExternalExam: {
		defaultValue: 'External Exam',
		displayPath: `${dpRoot}|${CrcatType.ExternalExam}`,
		description: `Credential requirement catalog type: '${CrcatType.ExternalExam}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.ExternalExam',
		portal: 'SP',
	},
	SPCrcatTypeEnumLab: {
		defaultValue: 'Lab',
		displayPath: `${dpRoot}|${CrcatType.Lab}`,
		description: `Credential requirement catalog type: '${CrcatType.Lab}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.Lab',
		portal: 'SP',
	},
	SPCrcatTypeEnumMiscellaneous: {
		defaultValue: 'Miscellaneous',
		displayPath: `${dpRoot}|${CrcatType.Miscellaneous}`,
		description: `Credential requirement catalog type: '${CrcatType.Miscellaneous}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.Miscellaneous',
		portal: 'SP',
	},
	SPCrcatTypeEnumParticipation: {
		defaultValue: 'Participation',
		displayPath: `${dpRoot}|${CrcatType.Participation}`,
		description: `Credential requirement catalog type: '${CrcatType.Participation}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.Participation',
		portal: 'SP',
	},
	SPCrcatTypeEnumProgramFee: {
		defaultValue: 'Program Fee',
		displayPath: `${dpRoot}|${CrcatType.ProgramFee}`,
		description: `Credential requirement catalog type: '${CrcatType.ProgramFee}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.ProgramFee',
		portal: 'SP',
	},
	SPCrcatTypeEnumStandingLengthyCert: {
		defaultValue: 'Standing Lengthy Certification',
		displayPath: `${dpRoot}|${CrcatType.StandingLengthyCert}`,
		description: `Credential requirement catalog type: '${CrcatType.StandingLengthyCert}'`,
		displayType: 'Content',
		feature: HubFeature.CredentialAchievements,
		legacyName: 'Credential.Achievements/System.Enum.CrcatType.StandingLengthyCert',
		portal: 'SP',
	},
	SPCrcatTypeEnumStandingMultiCert: {
		defaultValue: 'Standing Multi Certification',
		displayPath: `${dpRoot}|${CrcatType.StandingMultiCert}`,
		description: `Credential requirement catalog type: '${CrcatType.StandingMultiCert}'`,
		displayType: 'Content',
		feature: HubFeature.CredentialAchievements,
		legacyName: 'Credential.Achievements/System.Enum.CrcatType.StandingMultiCert',
		portal: 'SP',
	},
	SPCrcatTypeEnumTraining: {
		defaultValue: 'Training',
		displayPath: `${dpRoot}|${CrcatType.Training}`,
		description: `Credential requirement catalog type: '${CrcatType.Training}'`,
		displayType: 'Content',
		feature: HubFeature.Core,
		legacyName: 'Core/System.Enum.CrcatType.Training',
		portal: 'SP',
	},
};

export const CRCAT_TYPE_ENUM_LOCS = MapLocKeys<CPCrcatTypeLocs | SPCrcatTypeLocs>({
	...cpCrcatTypeEnumLocs,
	...spCrcatTypeEnumLocs,
});

export type CPCrcatTypeEnumLocType = LocMap<CPCrcatTypeLocs>;
export type SPCrcatTypeEnumLocType = LocMap<SPCrcatTypeLocs>;

export const cpCrcatTypeKeys: { [key in CrcatType]: keyof CPCrcatTypeEnumLocType } = {
	[CrcatType.AdditionalAgreement]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumAdditionalAgreement,
	[CrcatType.CeActivity]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumCeActivity,
	[CrcatType.CertAgreement]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumCertAgreement,
	[CrcatType.Enrollment]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumEnrollment,
	[CrcatType.ExternalCert]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumExternalCert,
	[CrcatType.ExternalExam]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumExternalExam,
	[CrcatType.Lab]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumLab,
	[CrcatType.Miscellaneous]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumMiscellaneous,
	[CrcatType.Participation]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumParticipation,
	[CrcatType.ProgramFee]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumProgramFee,
	[CrcatType.StandingLengthyCert]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumStandingLengthyCert,
	[CrcatType.StandingMultiCert]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumStandingMultiCert,
	[CrcatType.Training]: CRCAT_TYPE_ENUM_LOCS.CPCrcatTypeEnumTraining,
};

export const spCrcatTypeKeys: { [key in CrcatType]: keyof SPCrcatTypeEnumLocType } = {
	[CrcatType.AdditionalAgreement]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumAdditionalAgreement,
	[CrcatType.CeActivity]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumCeActivity,
	[CrcatType.CertAgreement]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumCertAgreement,
	[CrcatType.Enrollment]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumEnrollment,
	[CrcatType.ExternalCert]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumExternalCert,
	[CrcatType.ExternalExam]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumExternalExam,
	[CrcatType.Lab]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumLab,
	[CrcatType.Miscellaneous]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumMiscellaneous,
	[CrcatType.Participation]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumParticipation,
	[CrcatType.ProgramFee]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumProgramFee,
	[CrcatType.StandingLengthyCert]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumStandingLengthyCert,
	[CrcatType.StandingMultiCert]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumStandingMultiCert,
	[CrcatType.Training]: CRCAT_TYPE_ENUM_LOCS.SPCrcatTypeEnumTraining,
};
